export default __webpack_public_path__ + "static/media/right.c757e63d.svg";